import ABTest from '@/views/PushNotification/Messages/ABTest';
import ABTests from '@/views/PushNotification/Messages/ABTests';
import AutomatedABTest from '@/views/PushNotification/Messages/AutomatedABTest';
import AutomatedABTests from '@/views/PushNotification/Messages/AutomatedABTests';
import AutomatedMessage from '@/views/PushNotification/Messages/AutomatedMessage';
import AutomatedMessages from '@/views/PushNotification/Messages/AutomatedMessages';
import Message from '@/views/PushNotification/Messages/Message';
import Messages from '@/views/PushNotification/Messages/Messages';
import Template from '@/views/PushNotification/Messages/Template';
import Templates from '@/views/PushNotification/Messages/Templates';
import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';
import Audience from '../views/Audience.vue';
import Audiences from '../views/Audiences.vue';
import Experiment from '../views/Experiment.vue';
import Experiments from '../views/Experiments.vue';
import Home from '../views/Home.vue';
import NewHome from '../views/NewHome.vue';
import ISLKey from '../views/ISLKey.vue';
import ISLKeys from '../views/ISLKeys.vue';
import Parameter from '../views/Parameter.vue';
import Parameters from '../views/Parameters.vue';
import Signin from '../views/Signin.vue';
import AllExperiments from '../views/AllExperiments.vue';
import AuthLoginCallback from '../components/login/AuthLoginCallback.vue';
import AuthProcessingScreen from '../components/login/AuthProcessingScreen.vue';
import tokenManagerService, {oktaAuth} from '../services/tokenManager';
import UserCheck from '../views/UserCheck.vue';
import TemplateManagement from '@/views/TemplateManagement.vue';
import Admin from '@/views/Admin.vue';
import RetentionMessage from '@/views/RetentionMessage.vue';
import RetentionMessagesTab from '@/views/Retention/Messages.vue';
import RetentionImagesTab from '@/views/Retention/Images.vue';
import RetentionDefaultsTab from '@/views/Retention/Defaults.vue';
import RetentionDefaultProduct from '@/views/Retention/DefaultsProduct.vue';
import PermissionTest from '@/views/PermissionTest.vue';

Vue.use(VueRouter);
Vue.prototype.$auth = oktaAuth;

const initial_routes = [
    {
        path: '/',
        name: 'Home',
        component: NewHome
    },
    {
        path: '/classic',
        name: 'OldHome',
        component: Home
    },
    {
        path: '/signin',
        name: 'Signin',
        component: Signin
    },
    {
        path: '/login/callback',
        name: "LoginCallback",
        component: AuthLoginCallback, 
    },
    {
        path: '/auth/processing',
        name: 'AuthProcessing',
        component: AuthProcessingScreen,
        meta: { requiresAuth: false, noSidebar: true }
    },
    {
        path: '/:aid/parameters',
        name: 'Parameters',
        component: Parameters
    },
    {
        path: '/:aid/parameters/:id',
        name: 'Parameter',
        component: Parameter
    },
    {
        path: '/:aid/isl-keys',
        name: 'ISLKeys',
        component: ISLKeys
    },
    {
        path: '/:aid/isl-keys/:id',
        name: 'ISLKey',
        component: ISLKey
    },
    {
        path: '/:aid/audiences',
        name: 'Audiences',
        component: Audiences
    },
    {
        path: '/:aid/audiences/:id',
        name: 'Audience',
        component: Audience
    },
    {
        path: '/:aid/all-experiments',
        name: 'AllExperiments',
        component: AllExperiments
    },
    {
        path: '/:aid/experiments',
        name: 'Experiments',
        component: Experiments
    },
    {
        path: '/:aid/experiments/:id',
        name: 'Experiment',
        component: Experiment
    },
    {
        path: '/:aid/messages/message/:id?',
        name: 'MessagesMessage',
        component: Message
    },
    {
        path: '/:aid/messages/messages',
        name: 'MessagesMessages',
        component: Messages
    },
    {
        path: '/:aid/messages/templates',
        name: 'MessagesTemplates',
        component: Templates
    },
    {
        path: '/:aid/messages/template/:id?',
        name: 'MessagesTemplate',
        component: Template
    },
    {
        path: '/:aid/messages/ab-tests',
        name: 'MessagesABTests',
        component: ABTests
    },
    {
        path: '/:aid/messages/ab-test/:id?',
        name: 'MessagesABTest',
        component: ABTest
    },
    {
        path: '/:aid/messages/automated-ab-tests',
        name: 'MessagesAutomatedABTests',
        component: AutomatedABTests
    },
    {
        path: '/:aid/messages/automated-ab-test/:id?',
        name: 'MessagesAutomatedABTest',
        component: AutomatedABTest
    },
    {
        path: '/:aid/messages/automated-messages',
        name: 'MessagesAutomatedMessages',
        component: AutomatedMessages
    },
    {
        path: '/:aid/messages/automated-message/:id?',
        name: 'MessagesAutomatedMessage',
        component: AutomatedMessage
    },
    {
        path: '/:aid/user/user-check',
        name: 'UserCheck',
        component: UserCheck
    },
    {
        path: '/:aid/templates',
        name: 'TemplateManagement',
        component: TemplateManagement
    },
    {
        path: '/:aid/templates/new',
        name: 'template-new',
        component: () => import('../views/TemplateEdit.vue')
    },
    {
        path: '/:aid/templates/:id',
        name: 'template-edit',
        component: () => import('../views/TemplateEdit.vue'),
        props: true
    },
    {
        path: '/:aid/retention/message/:id?',
        name: 'RetentionMessage',
        component: RetentionMessage
    },
    {
        path: '/:aid/retention',
        redirect: to => ({ name: 'RetentionMessagesTab', params: to.params })
    },
    {
        path: '/:aid/retention/messages',
        name: 'RetentionMessagesTab',
        component: RetentionMessagesTab
    },
    {
        path: '/:aid/retention/images',
        name: 'RetentionImagesTab',
        component: RetentionImagesTab
    },
    {
        path: '/:aid/retention/defaults',
        name: 'RetentionDefaultsTab',
        component: RetentionDefaultsTab
    },
    {
        path: '/:aid/retention/realtime',
        name: 'RetentionRealtimeTab',
        component: () => import('../views/Retention/Realtime.vue')
    },
    {
        path: '/:aid/retention/defaults/:productId',
        name: 'RetentionDefaultProduct',
        component: RetentionDefaultProduct
    },
    {
        path: '/admin',
        name: 'Admin',
        component: Admin
    },
    {
        path: '/:aid/permission-test',
        name: 'PermissionTest',
        component: PermissionTest
    }
];


// ... existing imports

const routes = initial_routes.map((route) => {
    // 1. Check if it's explicitly public
    if (route.meta && route.meta.requiresAuth === false) {
        // We can keep 'requiresAuth: false' or just mark it as public
        return {
            ...route,
            meta: { ...route.meta, protected: false } // <--- Use 'protected' instead
        };
    }

    // 2. Default to Private
    return {
        ...route,
        meta: {
            ...route.meta,
            protected: true // <--- CHANGE THIS NAME. Okta ignores this.
        }
    };
});

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) return savedPosition;
        return { x: 0, y: 0 };
    }
});


router.beforeEach(async (to, from, next) => {
    
    // 1. PUBLIC ROUTES - ESCAPE HATCH (CRITICAL)
    // We check this FIRST to prevent race conditions on callbacks
    // If you used the meta fields above:
    if (to.meta.requiresAuth === false) {
        return next();
    }
    // Fallback for hardcoded paths if you didn't add meta fields yet:
    if (['/signin', '/login/callback', '/auth/processing'].includes(to.path)) {
        return next();
    }

    // 2. WAIT FOR INITIALIZATION (With Timeout Safety)
    // If the user refreshed the page on a deep link, main.js might not be done yet.
    if (!store.getters.isInitialized) {
        try {
             await Promise.race([
                new Promise(resolve => {
                    const unwatch = store.watch(
                        (state) => state.loading.initialized,
                        (val) => { if (val) { unwatch(); resolve(); } }
                    );
                }),
                // Safety timeout: If init takes > 3s, force proceed to avoid white screen of death
                new Promise(resolve => setTimeout(resolve, 3000))
            ]);
        } catch (e) {
            console.warn("⚠️ Router init wait timeout");
        }
    }

// 3. AUTHENTICATION CHECK
    // This is now the ONLY guard running for these routes
    try {
        const token = await tokenManagerService.getValidToken();
        
        if (!token) {
            console.log("🔒 Access denied. Redirecting to signin.");
            // Save the intended destination for post-login redirect
            if (to.fullPath !== '/' && to.fullPath !== '/signin') {
                sessionStorage.setItem('okta_redirect_path', to.fullPath);
            }
            return next('/signin');
        }
    } catch (error) {
        console.error("❌ Router auth check error:", error);
        // Handle token expiration or auth errors
        if (error.error === 'invalid_grant' || error.error === 'login_required' || error.errorCode === 'INTERNAL') {
            // Token manager will handle the redirect via event listeners
            // But we should also handle it here as a fallback
            if (to.fullPath !== '/' && to.fullPath !== '/signin') {
                sessionStorage.setItem('okta_redirect_path', to.fullPath);
            }
            return next('/signin');
        }
        // For other errors, still redirect to signin as a safety measure
        return next('/signin');
    }
    // 4. DATA LOADING (Optimized)
    // Ensure we have the base data needed for the UI
    try {
        const apps = store.getters.apps;
        
        // FIX: Check for null, empty array, OR empty object keys
        const isEmpty = !apps || 
                        (Array.isArray(apps) && apps.length === 0) || 
                        (typeof apps === 'object' && Object.keys(apps).length === 0);

        if (isEmpty) {
            console.log("📥 Apps list empty, fetching initial app data...");
            await store.dispatch('fetchApps');
        }
        // 5. CONTEXT SWITCHING
        // Handle switching the "Active App" based on URL params
        if (to.params.aid) {
            const currentAppId = store.getters.activeApp;
            // Only dispatch if it's actually changing to avoid overhead
            if (currentAppId !== to.params.aid) {
                console.log(`🔀 Context switching: ${currentAppId} -> ${to.params.aid}`);
                // We don't await this! Let the UI render optimistically or show a loader.
                // Blocking navigation for this feels slow to the user.
                store.dispatch('setActiveApp', to.params.aid).catch(err => {
                    console.error("Failed to set active app", err);
                    next('/'); // If invalid app ID, go home
                });
            }
        } else {
             // Logic for routes without an App ID (e.g. Dashboard root)
             const restrictedRoutes = ['Home', 'OldHome', 'Admin'];
             if (to.path !== '/' && !restrictedRoutes.includes(to.name)) {
                 return next('/');
             }
        }
    } catch (error) {
        console.error("❌ Router Data Error:", error);
        // If critical data fails, maybe let them through but the UI will show empty states
        // Or redirect to an error page
    }

    // 6. Proceed
    next();
});

export default router;
